/**
 * Los importes se manejan SIEMPRE en céntimos enteros para evitar errores de coma flotante.
 */

const eurFormatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

export function formatCents(cents: number): string {
  return eurFormatter.format(cents / 100);
}

/** Convierte euros (p. ej. 0.5 o "0,50") a céntimos. Devuelve null si no es válido. */
export function eurosToCents(value: number | string): number | null {
  const numeric = typeof value === 'number' ? value : Number(value.replace(',', '.').trim());
  if (!Number.isFinite(numeric)) return null;
  return Math.round(numeric * 100);
}

export function centsToEuros(cents: number): number {
  return cents / 100;
}

/** Porcentajes en puntos básicos: 2100 = 21 %. */
export function formatBasisPoints(bp: number): string {
  return `${(bp / 100).toLocaleString('es-ES', { maximumFractionDigits: 2 })} %`;
}
